import { extractErrorMessage } from '@mybonus/public';
import { useMemo } from 'react';

import type { APIError } from '../../api';
import { Paragraph } from '../Paragraph';

export type ErrorMessageProps = {
	error: null | undefined | false | Error | APIError | string;
};

export function ErrorMessage(props: ErrorMessageProps & { className?: string }) {
	const { error } = props;

	if (!error) {
		return <></>;
	}

	const msg = useMemo(() => extractErrorMessage(error), [error]);

	return (
		<Paragraph variant="error" className={props.className}>
			{msg}
		</Paragraph>
	);
}
